import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import './DemoRequests.css';
import DatePicker from 'react-datepicker';
import { useConfig } from '../../context/AppConfigContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import { useUser } from '../../context/UserContext';
import { handleFeedbackDownloadBtn, handleProductListDownload, getSalesUsers } from '../../services/accIqService';
import { PROJECT_DISPLAY_NAME } from '../../config/apiConfig';

const DemoRequests = () => {
  useAuth(); // Ensure the user is authenticated
  const { user } = useUser();
  const current_role_key = user?.role_key;
  const [success_message, setSuccessMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [demos, setDemos] = useState([]);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState('created_date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [filter, setFilter] = useState({});

  const [totalPages, setTotalPages] = useState(1);

  // const [action, setAction] = useState({action: ''});
  // const [checkedItems] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);
  const [updateDataStatus, setupdateDataStatus] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [showIndex, setShowIndex] = useState("");
  const [productData, setProductData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [salesUsers, setSalesUsers] = useState([]);

  const {appConfig} = useConfig();

  useEffect(() => {
    const fetchSalesUsers = async () => {
      const response = await getSalesUsers();
      setSalesUsers(response);
    }

    if(current_role_key === 'SUPER_ADMIN')
      fetchSalesUsers();
  }, []);

  const fetchDemoRequests = useCallback(async () => {
    setLoader(true);
    try {

      if(filter.seller_account_name === ''){
        delete(filter.seller_account_name)
      }

      if(filter.buyer_account_name === ''){
        delete(filter.buyer_account_name)
      }

      if(filter.sales_user === ''){
        delete(filter.sales_user)
      }

      if(filter.created_date === ''){
        delete(filter.created_date)
      }

      if(filter.demo_date_time === ''){
        delete(filter.demo_date_time)
      }

      if(filter.request_accepted === 0){
        delete(filter.request_accepted)
      }

      if(filter.salesiq_created === 0){
        delete(filter.salesiq_created)
      }

      if(filter.product_qc === 0){
        delete(filter.product_qc)
      }

      if(filter.research_qc === 0){
        delete(filter.research_qc)
      }

      if(filter.not_yet === 0){
        delete(filter.not_yet)
      }

      const filterData = { 
        "id": '', 
        page: currentPage,
        limit: perPage,
        sort_by: sortField,
        order: sortOrder,
        ...filter,
      };

      const response = await api.get('/demo_request/get_demo_requests', { "params": filterData });
      let demoRequests = response?.data?.data ?? [];
      // console.log("DEMO REQUESTS: "+JSON.stringify(demoRequests));
      setDemos(demoRequests);
      setTotalCount(response?.data?.total || 0);
      setTotalPages(Math.ceil(response?.data?.total / perPage));
  
    } catch (err) {
      setError(err.message || 'Failed to fetch requests');
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter, updateDataStatus]);
  

  useEffect(() => {
    // let successMessage = sessionStorage.getItem('successMessage');
    // if (successMessage) {
    //   setSuccessMessage(successMessage);
    //   sessionStorage.removeItem('successMessage');
    // }
    fetchDemoRequests();
  }, [fetchDemoRequests]);

  // useEffect(() => {
  //   if(checkedItems.length > 0 && checkedItems.length === demos.length){
  //     setSelectAll(true);
  //   }else{
  //     setSelectAll(false);
  //   }
  // }, [checkedItems])

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);    
    let temp = e.target;
    if (temp.value === 0) {
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      e.target.value = 0;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  if(!appConfig){
    return <div></div>;
  }

  // const accountTypes = appConfig.account_types;

  if(current_role_key === undefined){
    return <></>
  }
  if(current_role_key === 'CLIENT'){
    // navigate('/user_profile/profile');
    window.location.replace('/user_profile/profile');
  } else if(current_role_key === 'ANALYST') {
    // navigate('/dashboard');
    // window.location.replace('users/user_dashboard');
  }

  const handleShowDetail = (index) => {
    setShowIndex(index);
    setShowDetail(true);
    // let pd = JSON.parse(demos?.[index]?.csvData);
    let pd = typeof demos?.[index]?.csv_data == 'string' ? JSON.parse(demos?.[index]?.csv_data) : demos?.[index]?.csv_data;
    setProductData(pd);
  }

  const handleClose = () => {
    setShowDetail(false);
    setShowIndex("");
  }

  const handleDropdownChange = async (e, id, field) => {
    // const value = e.target.value;

    try {
      // const res = await api.post("/demo_request/update_demo_request", {
      //     _id: id,
      //     fieldName: field,
      //     value,
      // });

      setupdateDataStatus(prev => !prev);
      // console.log("Update success:", data);
      // Optionally update state here to reflect changes immediately
    } catch (err) {
      console.error("API update failed", err);
    }
  };

  const renderEditableCell = (demo, fieldName) => {
    const value = demo?.[fieldName];

    // if (value) {
    //   return "Yes";
    // }

    if (value) {
      const placeholders = {
        request_accepted: "Request accepted on",
        salesiq_created: "Account created on",
        product_qc: "Product Qc completed on",
        research_qc: "Research Qc completed on",
        feedback_incorporated: "Feedback incorporated on"
      };
      const place_holder = placeholders[fieldName] || "";

      return (
        <>
          Yes{" "}
          <i
            className="info-icon fa fa-info-circle"
            title={place_holder +" "+ new Date(value).toLocaleString("en-US", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })} // or your custom format
            style={{ cursor: "pointer", marginLeft: "4px" }}
          >
          </i>
        </>
      );
    }

    const shouldAdminSeeDropdown = () => {
      if (current_role_key !== "SUPER_ADMIN") return false;

      if (fieldName === "request_accepted") return true;
      if (fieldName === "salesiq_created") return demo?.request_accepted;
      if (fieldName === "product_qc") return demo?.request_accepted && demo?.salesiq_created;

      return false;
      // Conditions for each admin field
      // if (fieldName === "request_accepted") return true;

      // if (fieldName === "salesiq_created") {
      //   return demo?.request_accepted;
      // }

      // if (fieldName === "salesiq_created") {
      //   return demo?.salesiq_created;
      // }

      // if (fieldName === "product_qc") {
      //   return demo?.request_accepted && demo?.salesiq_created;
      // }

    };

    const shouldAnalystSeeDropdown = () => {
      return (
        current_role_key === "ANALYST" &&
        demo?.request_accepted &&
        demo?.salesiq_created &&
        demo?.product_qc
        // && demo?.research_qc
      );
    };

    const shouldShowFileUpload = () => {
      return (
        current_role_key === "ANALYST" &&
        fieldName === "feedback_upload" &&
        demo?.request_accepted &&
        demo?.salesiq_created &&
        demo?.product_qc &&
        demo?.research_qc
      );
    };

    if (fieldName === "feedback_upload" && demo?.feedback_file) {
      if(current_role_key === "SUPER_ADMIN"){
        return (demo?.feedback_file?.length > 0 ? (<td>
          <span style={{textDecoration: "underline", cursor: 'pointer'}} onClick={() => handleFeedbackDownloadBtn(demo?._id)}>Download</span>
        </td>) : <td></td>)
      }else{
        return "Uploaded";
      }
    }

    if (shouldShowFileUpload()) {
      return (
        <input
          type="file"
          className="form-control"
          onChange={(e) =>
            handleFileUpload(e.target.files[0], demo?._id, fieldName)
          }
        />
      );
    }

    if (current_role_key === "ANALYST" && fieldName === "feedback_upload") {
      return null;
    }

    if (fieldName === "feedback_incorporated") {
      if (current_role_key === "SUPER_ADMIN" && demo?.feedback_file?.length > 0) {
        return (
          <select
            className="form-select font13"
            style={{"padding": '3px 5px'}}
            value={value || ""}
            onChange={(e) => handleDropdownChange(e, demo?._id, fieldName)}
          >
            <option value="">Pending</option>
            <option value="Yes">Yes</option>
          </select>
        );
      }

      return "";
    }

    if (shouldAdminSeeDropdown() || shouldAnalystSeeDropdown()) {
      return (
        <select
          className="form-select font13"
          style={{"padding": '3px 5px'}}
          value={value || ""}
          onChange={(e) => handleDropdownChange(e, demo?._id, fieldName)}
        >
          <option value="">Pending</option>
          {/* <option value="No">No</option> */}
          <option value="Yes">Yes</option>
        </select>
      );
    }

    return value || "";
  };

  const handleFileUpload = async (file, id, fieldName) => {
    const formData = new FormData();
    formData.append("_id", id);
    formData.append("feedback_file", file);
    formData.append("fieldName", fieldName);

    try {
      // const res = await api.post("/demo_request/feedback_upload", formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data"
      //   }
      // });

      setupdateDataStatus(prev => !prev);
      // console.log("Upload success:", data);

      // Optionally update state to reflect file upload status
    } catch (err) {
      console.error("File upload failed", err);
    }
  };

  const handleCreatedDateChange = (dates) => {
    const [created_start_date, created_end_date] = dates;
    setFilter({ ...filter, created_start_date, created_end_date });
  };

  const handleDemoDateChange = (dates) => {
    const [demo_start_date, demo_end_date] = dates;
    setFilter({ ...filter, demo_start_date, demo_end_date });
  };

  // const handleCSVDownload = async () => {
  //   let response = {};
  //   try {
  //     response = await api.post("/demo_request/export_all_demo_requests", {}, {
  //       responseType: "blob"
  //     });
  //     const blob = new Blob([response.data], { type: "text/csv" });
  //     const url = window.URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "export.csv";
  //     a.style.display = "none";
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);

  //     window.URL.revokeObjectURL(url);

  //   } catch (err) {
  //     console.error("API update failed", err);
  //   }
  // };

  return (
    <div className="add_company_wrapper">
      {loader === true && <ScreenLoader />}
      <div className="container-fluid mt-3 p-4">
        {success_message && <Alert type="success" message={success_message} />}
        {error && <Alert type="danger" message={error} />}

        <div className="row">
          <div className="col-md-9">
            <h4 className="blue add_user_heading">Demo Requests</h4>
          </div>

          <div className="row mb-3 mt-4">
            <div className="col-md-12">
              <div className="left_filter">
                <div className="admin_filter_head">
                  <h5 className="">Filter</h5>
                </div>
                <div className="row">

                  {current_role_key === 'SUPER_ADMIN' && <div className="col d-inline-block">
                    <select
                        className="custom_form_control w-100 form-control"
                        as="select"
                        id="selectfilter"
                        name="sales_user"
                        value={filter.selected_user}
                        onChange={(e) => setFilter({ ...filter, [e.target.name]: e.target.value })}
                      >
                        <option key="" value="">
                          Select Sales User
                        </option>
                        {salesUsers.map((user) => (
                          <option key={user._id} value={user._id}>
                            {user.name}
                          </option>
                        ))}
                      </select>
                  </div>}

                  <div className="col d-inline-block">
                    <input
                      type="text"
                      className="form-control custom_form_control"
                      placeholder="Filter by Seller"
                      name="seller_account_name"
                      value={filter.seller_account_name}
                      onChange={(e) => setFilter({ ...filter, [e.target.name]: e.target.value })}
                    />
                  </div>

                  <div className="col d-inline-block">
                    <input
                      type="text"
                      className="form-control custom_form_control"
                      placeholder="Filter by Buyer"
                      name="buyer_account_name"
                      value={filter.buyer_account_name}
                      onChange={(e) => setFilter({ ...filter, [e.target.name]: e.target.value })}
                    />
                  </div>

                  <div
                    className="col show_archived d-block"
                  >
                    <DatePicker
                      selectsRange
                      startDate={filter.created_start_date}
                      endDate={filter.created_end_date}
                      onChange={handleCreatedDateChange}
                      dateFormat="MMMM d, yyyy"
                      placeholderText="Select created date range"
                      className="form-control custom_form_control"
                      autoComplete="off"
                      isClearable
                    />
                  </div>

                  <div
                    className="col show_archived d-block"
                  >
                    <DatePicker
                      selectsRange
                      startDate={filter.demo_start_date}
                      endDate={filter.demo_end_date}
                      onChange={handleDemoDateChange}
                      dateFormat="MMMM d, yyyy"
                      placeholderText="Select demo date range"
                      className="form-control custom_form_control"
                      autoComplete="off"
                      isClearable
                    />
                  </div> 
                </div>

                <div className='row'>
                  <div className='d-flex'>
                      <div className="d-inline-block mr-4">
                      <input
                        id="request_accepted"
                        type="checkbox"
                        className="form-check-input custom_input_type"
                        name="request_accepted"
                        value={filter.request_accepted}
                        onClick={handleFilterChange}
                      />{" "}
                      <label
                        className="form-check-label custom_lable_type"
                        htmlFor="request_accepted"
                      >
                        Request Accepted
                      </label>
                    </div>

                    <div className="d-inline-block mr-4">
                      <input
                        id="salesiq_created"
                        type="checkbox"
                        className="form-check-input custom_input_type"
                        name="salesiq_created"
                        value={filter.salesiq_created}
                        onClick={handleFilterChange}
                      />{" "}
                      <label
                        className="form-check-label custom_lable_type"
                        htmlFor="salesiq_created"
                      >
                        SalesPlay (Account) Created
                      </label>
                    </div>

                    <div className="d-inline-block mr-4">
                      <input
                        id="product_qc"
                        type="checkbox"
                        className="form-check-input custom_input_type"
                        name="product_qc"
                        value={filter.product_qc}
                        onClick={handleFilterChange}
                      />{" "}
                      <label
                        className="form-check-label custom_lable_type"
                        htmlFor="product_qc"
                      >
                        Product Qc
                      </label>
                    </div>

                    <div className="d-inline-block mr-4">
                      <input
                        id="research_qc"
                        type="checkbox"
                        className="form-check-input custom_input_type"
                        name="research_qc"
                        value={filter.research_qc}
                        onClick={handleFilterChange}
                      />{" "}
                      <label
                        className="form-check-label custom_lable_type"
                        htmlFor="product_qc"
                      >
                        Research Qc
                      </label>
                    </div>

                    <div className="d-inline-block mr-4">
                      <input
                        id="research_qc"
                        type="checkbox"
                        className="form-check-input custom_input_type"
                        name="not_yet"
                        value={filter.not_yet}
                        onClick={handleFilterChange}
                      />{" "}
                      <label
                        className="form-check-label custom_lable_type"
                        htmlFor="not_yet"
                      >
                        Not Yet
                      </label>
                    </div>

                    <div className=" show_archived d-block">
                      <div className="d-inline-block ml-2">
                        {/* <button className="btn btn-primary" onClick={handleCSVDownload}>
                          Export to CSV
                        </button> */}
                      </div>
                    </div>
                      
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-bordered font13">
            <thead>
              <tr className="cursor_p">
                
                <th onClick={() => handleSort("name")} style={{minWidth: '150px'}}>
                  User
                  {sortField === "name" && (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("seller_account_name")} style={{ whiteSpace: "nowrap" }} >
                  Seller Company
                  {sortField === "seller_account_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("buyer_account_name")} style={{ whiteSpace: "nowrap" }}>
                  Buyer Company
                  {sortField === "buyer_account_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("created_date")} style={{minWidth: '160px'}}>
                  Demo Requested On
                  {sortField === "created_date" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("demo_date_time")} style={{minWidth: '150px'}}>
                  Demo Date
                  {sortField === "demo_date_time" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("request_accepted")} style={{width: '110px', minWidth: '110px'}}>
                  Request Accepted
                  {sortField === "request_accepted" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("salesiq_created")} style={{width: '110px', minWidth: '110px'}}>
                  {PROJECT_DISPLAY_NAME} Created
                  {sortField === "salesiq_created" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("product_qc")}>
                  Product QC
                  {sortField === "product_qc" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("research_qc")}>
                  Research QC
                  {sortField === "research_qc" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                {current_role_key === "SUPER_ADMIN" && <th>Products</th>}
                <th>Feedback</th>
                <th>Feedback Incorporated</th>
                <th style={{cursor: 'select'}}>
                  RequestID
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {demos?.length > 0 ? (
                demos.map((demo, index) => {
                  let created = new Date(demo?.created_date);
                  let demoDate = new Date(demo?.demo_date_time);

                  return (
                    <tr key={`demo-list-${index}`}>
                      <td>{demo?.name}</td>
                      <td>{demo?.seller_account_website}</td>
                      <td>{demo?.buyer_account_website}</td>
                      <td>
                        {created.toLocaleString("en-US", {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>
                        {demoDate.toLocaleString("en-US", {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>{renderEditableCell(demo, "request_accepted")}</td>
                      <td>{renderEditableCell(demo, "salesiq_created")}</td>
                      <td>{renderEditableCell(demo, "product_qc")}</td>
                      <td>{renderEditableCell(demo, "research_qc")}</td>
                      {current_role_key === "SUPER_ADMIN" ? (
                        demo?.product_list_csv?.length > 0 ? (
                          <td>
                            <span
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleProductListDownload(demo?._id)
                              }
                            >
                              Download
                            </span>
                          </td>
                        ) : (
                          <td></td>
                        )
                      ) : (
                        ""
                      )}
                      <td>{renderEditableCell(demo, "feedback_upload")}</td>
                      <td>{renderEditableCell(demo, "feedback_incorporated")}</td>
                      <td>{demo?._id}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          style={{ border: "none", fontSize: "12px" }}
                          onClick={() => handleShowDetail(index)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={11}
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    No requests yet !!!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="text-muted mb-2" style={{ display: "inline-block" }}>
          Showing {(currentPage - 1) * perPage + 1} to{" "}
          {(currentPage - 1) * perPage + demos.length} of {totalCount} records
        </div>

        <nav style={{ display: "inline-block", float: "right" }}>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handleFirstPage} className="page-link">
                First
              </button>
            </li>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handlePrevPage} className="page-link">
                Prev
              </button>
            </li>
            {getPageNumbers().map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${
                  pageNumber === currentPage ? "active" : ""
                }`}
              >
                <button
                  onClick={() => handlePageChange(pageNumber)}
                  className="page-link"
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button onClick={handleNextPage} className="page-link">
                Next
              </button>
            </li>
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button onClick={handleLastPage} className="page-link">
                Last
              </button>
            </li>
          </ul>
        </nav>
      </div>

      {showDetail && (
        <Modal show="true" onHide={handleClose} centered className="modal-lg">
          <Modal.Header closeButton>
            <Modal.Title>Demo/Trial Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-3">
              <div className="col-md-12 ">
                <div
                  htmlFor="labelCompanyName"
                  className="form-label custom_label"
                >
                  {/* <h2 className="text-2xl font-bold mb-4">Demo Request Form</h2> */}
                  <Row className="g-3">
                    {/* <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Request type:{" "}
                      </label>
                      <p>
                        {demos?.[showIndex]?.request_type === "new"
                          ? "Demo"
                          : "Trial"}
                      </p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Round of demo:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.round_of_demo}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Seller account name:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.seller_account_name}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Buyer account name:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.buyer_account_name}</p>
                    </Col> */}

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        CRM Lead ID:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.lead_id}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Demo date & time:{" "}
                      </label>
                      <p>
                        {demos?.[showIndex]?.demo_date_time?.length
                          ? new Date(
                              demos?.[showIndex]?.demo_date_time
                            ).toLocaleString("en-US", {
                              weekday: "short",
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : ""}
                      </p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Client Linkedin Url:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.clientLinkedinUrl}</p>
                    </Col>

                    <Col md={6}>
                     
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Seller account website:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.seller_account_website}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Buyer account website:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.buyer_account_website}</p>
                    </Col>

                    {/* <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Seller industry:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.seller_industry}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Buyer industry:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.buyer_industry}</p>
                    </Col> */}

                    {/* ++++++++++++++++++++++++++++++++++++++ */}
                    {/* <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        No of accounts:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.no_of_accounts}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        No of users:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.no_of_users}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Account type:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.account_type}</p>
                    </Col> */}
                    {/* ++++++++++++++++++++++++++++++++++++++ */}

                    

                    <Col md={12}>
                      <label className="popUpSubHeading" htmlFor="">
                        What tools are your reps using today to research accounts or find new opportunities?:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.question}</p>
                    </Col>

                    <Col md={12}>
                      <label className="popUpSubHeading" htmlFor="">
                        KPIs that falling short today:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.kpi}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Currently exploring new GTM / sales tools:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.exploringTools}</p>
                    </Col>

                    

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Focus area :{" "}
                      </label>
                      <p>{demos?.[showIndex]?.growthFocus}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Sales team size :{" "}
                      </label>
                      <p>{demos?.[showIndex]?.salesTeamSize}</p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Decision Makers :{" "}
                      </label>
                      <p>{demos?.[showIndex]?.decisionMakers}</p>
                    </Col>
                    

                    {/* <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Salesperson name:{" "}
                      </label>
                      <p>
                        {demos?.[showIndex]?.sales_person_name_and_designation}
                      </p>
                    </Col>

                    <Col md={6}>
                      <label className="popUpSubHeading" htmlFor="">
                        Icp name & designation:{" "}
                      </label>
                      <p>{demos?.[showIndex]?.icp_name_and_designation}</p>
                    </Col> */}

                    

                    <Col md={12} className='table-responsive'>
                      <label className="popUpSubHeading" htmlFor="">
                        Product list:{" "}
                      </label>
                      {/* <pre>
                        {JSON.stringify(demos?.[showIndex]?.csvData, null, 2)}
                      </pre> */}
                      <table className="table table-striped table-bordered border font14">
                        
                        <thead class="thead-dark">
                          <tr>
                            <th>Product</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                        {productData?.length > 0 ? (
                          productData.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {/* {item.Product} */}
                                {item.name}
                              </td>
                              <td>
                                {/* {item.Description} */}
                                {item.description}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2">No data available</td>
                          </tr>
                        )}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default DemoRequests;